import StyledChip from "../DayChips/StyledChip";
import { palette } from "../../theme/palette";

export const Duration = ({ selected, onChange, options, disabled }) => {
  return (
    <div>
      {options.map((option, index) => {
        return (
          <StyledChip
            size={"small"}
            clickable
            disabled={disabled}
            label={`${option}h`}
            key={index}
            onClick={() => onChange(option)}
            style={
              selected === option
                ? {
                    backgroundColor: palette.dpdRed,
                    color: palette.typography.white.high,
                  }
                : {}
            }
          />
        );
      })}
    </div>
  );
};
